"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _radioButton = require("./radioButton.style");

var _excluded = ["name", "label"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioButton = function RadioButton(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _radioButton.useStyle)();

  var name = props.name,
      label = props.label,
      htmlAttributes = _objectWithoutProperties(props, _excluded); // const radioBtnId = `radioBtn-${Date.now()}`;


  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.div
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: classes.label
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: classes.radioButton,
    type: "radio",
    name: name
  }, htmlAttributes)), label));
};

exports.RadioButton = RadioButton;
RadioButton.propTypes = {
  /** radio button name attr for radio buttons group */
  name: _propTypes["default"].string,

  /** label of radio button */
  label: _propTypes["default"].string
};
RadioButton.defaultProps = {
  name: "radioBtn",
  label: null
};